import { services } from '../services';
var action = "stockjournal";

export const stockjournalService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    confirm
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function confirm(object) {
    return services.restApi(`${action}/confirm`, 'POST', object);
}